// Helpers to keep anchor ids and links clean.
// CMS/API data sometimes provides anchor values that already contain a
// leading "#" (e.g. "#kontakt"). Rendering those values directly results in
// invalid ids like id="#kontakt" or double-hash links like href="##kontakt".

// Removes any leading "#" characters. Use it when setting an element id
// from an anchor value (e.g. id={stripHash(data.anchorId)}).
export const stripHash = (value) =>
    typeof value === 'string' ? value.replace(/^#+/, '') : value;

// Collapses any leading "#" characters into a single "#" so anchor links
// never end up with a double hash. Non-string and external values are left
// untouched (only a leading run of "#" is normalized).
export const normalizeAnchorHref = (value) =>
    typeof value === 'string' ? value.replace(/^#+/, '#') : value;

// Some room-table links carry a preselection hint after a pipe, e.g.
// "#kontakt|Große Seminarräume". This splits the value into the actual anchor
// (the part before the pipe) and the optional room name (the part after it),
// so the anchor can be used for navigation while the room is used to
// pre-select a form value.
export const parseAnchorRoom = (value) => {
    if (typeof value !== 'string') {
        return {anchor: value, room: null};
    }
    const pipeIndex = value.indexOf('|');
    if (pipeIndex === -1) {
        return {anchor: value, room: null};
    }
    const room = value.slice(pipeIndex + 1).trim();
    return {
        anchor: value.slice(0, pipeIndex),
        room: room || null,
    };
};

// Event used to tell a room contact form which room should be pre-selected
// when a room-table link is clicked.
export const ROOM_PRESELECT_EVENT = 'db:preselect-room';

// Broadcasts a room preselection request so any mounted room contact form can
// pick it up. Safe to call in non-browser environments.
export const emitRoomPreselect = (room) => {
    if (
        room &&
        typeof window !== 'undefined' &&
        typeof window.CustomEvent === 'function'
    ) {
        window.dispatchEvent(
            new window.CustomEvent(ROOM_PRESELECT_EVENT, {detail: {room}})
        );
    }
};
